const deleteSearchParam = (name) => {
	const url = new URL(window.location.href);
	if (url.searchParams.has(name)) {
		url.searchParams.delete(name);
		window.history.replaceState({}, '', url.toString());
	}
};

export const getSearchParam = (name) => {
	const url = new URL(window.location.href);
	const paramValue = url.searchParams.get(name);
	return paramValue ? decodeURIComponent(paramValue) : '';
};

export const consumeSearchParam = (name) => {
	const param = getSearchParam(name);
	param && deleteSearchParam(name);
	return param;
};
